<div class="text-center">
  <p-loader size="large"></p-loader>
  <div class="mt-4">Authentification en cours ..</div>
</div>
